import { Navigate } from "react-router-dom";
import { useCrypto } from "../../hooks/CryptoHooks";

const Logout = () => {
    const { clearKeys } = useCrypto();

    clearKeys();
    return <Navigate to="/login" />;
};

export default Logout;
